export const mikolajRak = {
    'meta': {
        'title': 'Lekarz rezydent psychiatrii Mikołaj Rak • COLLIGO',
        'description': 'Jestem lekarzem odbywającym rezydenturę w dziedzinie Psychiatrii. W swojej pracy z pacjentem zajmuję się diagnostyką i leczeniem wszystkich zaburzeń psychicznych u osób dorosłych.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-rak/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/mikolaj-rak.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra w Bydgoszczy Mikołaj Rak'
        }
    }
}